import { render, staticRenderFns } from "./TeamSnippet.vue?vue&type=template&id=3cdb2890&"
import script from "./TeamSnippet.vue?vue&type=script&lang=js&"
export * from "./TeamSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports